var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7732 0C15.7613 0 14.1303 1.63096 14.1303 3.64286V19.125C14.1303 21.1369 15.7613 22.7679 17.7732 22.7679H33.2553C35.2672 22.7679 36.8982 21.1369 36.8982 19.125V3.64286C36.8982 1.63096 35.2672 0 33.2553 0H17.7732ZM3.64286 28.2321C1.63096 28.2321 0 29.8631 0 31.875V47.3571C0 49.369 1.63096 51 3.64286 51H19.125C21.1369 51 22.7679 49.369 22.7679 47.3571V31.875C22.7679 29.8631 21.1369 28.2321 19.125 28.2321H3.64286ZM28.2321 31.875C28.2321 29.8631 29.8631 28.2321 31.875 28.2321H47.3571C49.369 28.2321 51 29.8631 51 31.875V47.3571C51 49.369 49.369 51 47.3571 51H31.875C29.8631 51 28.2321 49.369 28.2321 47.3571V31.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/Others.47113dbfef6a6080c479530a710f5a78.svg";
export { ForwardRef as ReactComponent };